/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classNames from 'classnames';
import some from 'lodash/some'

import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { TabMenu } from 'primereact/tabmenu';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';

import { LANGUAGE_DEFAULT, LANGUAGE_AND_CODE } from '@constants/general';

class LanguageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      keysLenguages: [],
      itemsTabsLenguages: [],
      keyEs: null,
      activeTabIndex: 0,
      errors: [],
      nameEs: '',
      justification: ''
    }
    this.initialValuesForm = {
      name: ''
    };
  }

  componentDidMount() {
    const {
      languagesList,
      t,
      i18n
    } = this.props;
    
    const getCurrentLanguage = i18n.language
    let keysLenguages = languagesList.map(item => (item.clave))
    keysLenguages = keysLenguages.filter(item => item !== LANGUAGE_DEFAULT)
    const keyEs = languagesList.filter(item => item.clave === LANGUAGE_DEFAULT)[0]
    const itemsTabsLenguages = languagesList.reduce((accum, item) => {
      if (item.clave === LANGUAGE_DEFAULT) return accum
      accum.push({ label: item.nombre[getCurrentLanguage], key: item.clave })
      return accum
    }, [])

    this.setState({
      keysLenguages,
      keyEs,
      itemsTabsLenguages
    })

    keysLenguages.map((item) =>
      this.setState({ [item]: { ...this.initialValuesForm } })
    );
    this.setState({ loadingPage: false });
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { onContinueAction, onHidden } = this.props
    const { keysLenguages, nameEs, justification } = this.state
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
    let name = keysLenguages.reduce((accum, item) => {
      if (this.state[item].name) accum[item] = this.state[item].name;
      return accum;
    }, {});
    Object.assign(name, {[LANGUAGE_DEFAULT]: nameEs.name});
    onContinueAction({name, code: nameEs.code}, justification)
    return onHidden()
  }

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeSimple = ({ target }) => {
    if (target.name === 'nameEs') this.setState((prevState) => ({
      keysLenguages: [...prevState.keysLenguages, target.value.code],
      itemsTabsLenguages: [...prevState.itemsTabsLenguages, {label: target.value.name, key: target.value.code} ],
      [target.value.code]: { ...this.initialValuesForm }
    }))
    this.setState({
      [target.name]: target.value
    }), () => this.validateFieldsOnchange(target.name, target.value);
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t } = this.props
    const { nameEs, justification } = this.state
    let errors = {}
    if (!nameEs) errors = {...errors, [`nameEs`]: `${t('Nombre')} ${t('es requerido')}`}
    if (!justification) errors = {...errors, [`justification`]: `${t('Justificación del cambio')} ${t('es requerido')}`}
    this.setState({errors})
    return errors
  }

  render () {
    const { t, onHidden, i18n } = this.props
    const { activeTabIndex, keysLenguages, itemsTabsLenguages, errors, loadingPage, keyEs } = this.state
    
    const isFormFieldValid = (name) =>
    !!(errors[name]);
  
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      return (
        <>
          <div className="p-col-12 p-field">
            <InputText
              name={`${prefixLenguage}-name`}
              value={this.state[prefixLenguage]?.name}
              onChange={this.onChange}
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-name`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-name`)}
          </div>
        </>
      );
    };

    const children = (
      <form className="p-mt-2 p-fluid" onSubmit={this.onSubmit}>
        <div className="p-col-12 p-field">
          <label htmlFor="title" className="p-text-bold p-pb-2">
            {keyEs ? keyEs?.nombre[i18n.language] : ''} {t('Obligatorio')}
          </label>
          <Dropdown
            name="nameEs"
            value={this.state.nameEs}
            options={LANGUAGE_AND_CODE}
            optionLabel="name"
            onChange={this.onChangeSimple}
            className={classNames({
              'p-invalid': isFormFieldValid(`nameEs`),
            })}
            autoFocus
            // editable
            filter
            filterBy="name"
          />
          {getFormErrorMessage(`nameEs`)}
        </div>
        <div className="p-col-12">
          {itemsTabsLenguages && (
            <TabMenu
              model={itemsTabsLenguages}
              activeIndex={activeTabIndex}
              onTabChange={(e) =>
                this.setState({ activeTabIndex: e.index })
              }
            />
          )}
        </div>
        {itemsTabsLenguages.length ? renderByTabLenguage() : ''}
        <div className='p-col-12'>
          <label className="">{t('Justificación del cambio')}</label>
          <InputTextarea
            name="justification"
            onChange={(e) =>
              this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
            }
            rows={5}
            cols={30}
            className={classNames({
              'p-invalid': isFormFieldValid(`justification`),
            })}
          />
          {getFormErrorMessage(`justification`)}
        </div>
        <div className="p-dialog-footer custom">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button> 
            <button className="p-button p-component" type="submit">
              <span className="p-button-label p-c">Guardar</span>
            </button>
          </div>
        </div>
      </form>
    )

    if (loadingPage) return true;
    return (
      <Dialog
        header={t('Nuevo idioma')}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '50vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
});

export default compose(withTranslation(), connect(mapStateToProps, null))(LanguageModal)